var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"multi-card-event"},_vm._l((_vm.events),function(event){return _c('event-card',{key:event.uuid,staticClass:"event-card",attrs:{"event":event}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }